import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = {
  children: ReactNode;
  scope: "page" | "checkout";
  onError?: () => void;
};

/** Keep a failed payment element or lazy module from unmounting the entire page. */
export class WatchErrorBoundary extends Component<Props, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`Watch ${this.props.scope} failed`, error, info.componentStack);
    this.props.onError?.();
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const page = this.props.scope === "page";
    return (
      <div
        role="alert"
        className={page ? undefined : "watch-error"}
        style={page ? {
          minHeight: "100svh", boxSizing: "border-box", padding: 28,
          display: "grid", placeContent: "center", textAlign: "center",
          background: "#07070a", color: "#f7f6f9", fontFamily: "Inter, system-ui, sans-serif",
        } : undefined}
      >
        <p>{page ? "This page couldn’t load." : "Checkout couldn’t load."}</p>
        <p>Reload to continue from this step.</p>
        <button
          type="button"
          className={page ? undefined : "watch-primary"}
          style={page ? {
            background: "#ff4f7d", color: "#fff", border: 0, borderRadius: 14,
            padding: "16px 24px", font: "inherit", fontWeight: 600, cursor: "pointer",
          } : undefined}
          onClick={() => window.location.reload()}
        >
          Reload page
        </button>
      </div>
    );
  }
}
